'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(Sparse) {
  var axisScales = function axisScales(params, data) {
    var sparseData = new Sparse(getSparseWidth);
    /**
     * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
     * @param d
     * @returns {Array}
     */
    var yMin = d3.min(data, function (d) {
      return Math.min(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
    });
    var yMax = d3.max(data, function (d) {
      return Math.max(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
    });
    var padding = 0.1;
    var outerPadding = 0.05;
    params.xScaleFactor = sparseData.scaleFactor(data, params.width);
    params.xRange = sparseData.thickPoints(data, params.xScaleFactor);
    params.xWidth = sparseData.scaleWidth(data, params.xScaleFactor);
    params.xWidthFromLengthOfStay = sparseData.getWidthFromLengthOfStay(data, params.xScaleFactor);
    var x = d3.scale.ordinal().domain(_.map(data, 'lengthOfStay')).rangeBands([0, params.width], padding, outerPadding).range(data.map(params.xRange).concat([params.width]));
    var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
    function getSparseWidth(d) {
      return (d && d.gapLength) * params.xGapSize || params.xDataSize;
    }
    return {
      xScale: x,
      yScale: y
    };
  };
  return axisScales;
};
Scales.$inject = ['ChartElementsSparseLengthOfStay'];
module.exports = Scales;